import { BaseAPIModel } from '@weezevent/weezjs-core';

/**
 * TaxModel.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class TaxModel extends BaseAPIModel {
    fields() {
        return {
            pk: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl() {
        return `/ticket/tax`;
    }
}
